import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-connexion',
  templateUrl: './connexion.component.html',
  styleUrls: ['./connexion.component.scss']
})
export class ConnexionComponent implements OnInit {
  nbrLicence: any = 1;
  title: any;

  constructor(
    private router: Router,
    public dialogLicence: MatDialogRef<ConnexionComponent>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any) {
     }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  updateAccount(){
    console.log("toto");
  }



  closed(event){
    this.dialogLicence.close(event);
  }

  login() {

    this.dialogLicence.close();
      

  }

  goToLogin(){
    this.dialogLicence.close();
    this.router.navigateByUrl("/members/firstLogin");
  }

  goToBailleur(){
    window.open('https://receipt2go.web.app', '_blank');
  }

}
